const SW_URL = `${process.env.PUBLIC_URL || ''}/sw.js`;

let updateListeners = [];
let waitingWorker = null;

const notifyUpdateAvailable = (worker) => {
  waitingWorker = worker;
  updateListeners.forEach((listener) => listener());
};

export const onServiceWorkerUpdate = (listener) => {
  updateListeners.push(listener);

  // A worker may already be waiting by the time a listener subscribes.
  if (waitingWorker) {
    listener();
  }

  return () => {
    updateListeners = updateListeners.filter((item) => item !== listener);
  };
};

export const applyServiceWorkerUpdate = () => {
  if (!waitingWorker) {
    window.location.reload();
    return;
  }

  waitingWorker.postMessage({ type: 'SKIP_WAITING' });
  waitingWorker = null;
};

export const registerServiceWorker = () => {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) {
    return;
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(SW_URL)
      .then((registration) => {
        if (registration.waiting) {
          notifyUpdateAvailable(registration.waiting);
        }

        registration.addEventListener('updatefound', () => {
          const installing = registration.installing;
          if (!installing) {
            return;
          }

          installing.addEventListener('statechange', () => {
            // "installed" with an existing controller means a newer build is ready.
            if (installing.state === 'installed' && navigator.serviceWorker.controller) {
              notifyUpdateAvailable(installing);
            }
          });
        });
      })
      .catch(() => undefined);

    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshing) {
        return;
      }
      refreshing = true;
      window.location.reload();
    });
  });
};
